exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/sachinmacbook/Sites/ngfront/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/sachinmacbook/Sites/ngfront/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/sachinmacbook/Sites/ngfront/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles